import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';

Vue.config.productionTip = false

import setupInterceptors from './services/setupInterceptors';


//console.log('env', JSON.stringify(process.env))

Vue.use(VeeValidate);
setupInterceptors(store);
Vue.use(Vuex);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
